  <!-- 外请应付账单明细 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" @selectChange="handleSelectionChange" ref="mytable" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
         <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "外请应付账单明细", //导出时默认文件名
        apiName: "/admin/v3/tms/report/getDispatchProfitList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "导出",
          method: "exportData",
          permissVal: "aaaaa",
        },
        {
          name: "表格设置",
          method: "SetTable",
          permissVal: "aaaaa",
        },
        {
          name: "打印",
          method: "printData",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      //  查询框
      baseConfig: [
        {
          type: "timeSelect",
          slotName: "time1",
        },

        // {
        //   type: "input",
        //   label: "运单号",
        //   field: "id",
        //   placeholder: "请输入",
        // },
        // {
        //   type: "input",
        //   label: "车牌号",
        //   field: "id",
        //   placeholder: "请输入",
        // },
        {
          type: "input",
          label: "发车批次号",
          field: "dispatchNumber",
          placeholder: "请输入",
        },
      ],

      queryData: {
        dispatchNumber: null,
      },
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "过账时间",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "发车批次号",
          field: "dispatchNumber",

          width: "120", // default：120
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计 default：false
          isSort: false, //表格设置里面是否可以排序 default：false
        },
        {
          name: "业务日期",
          field: "departureTime",
          sort: 4,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },

        {
          name: "结算对象代码",
          field: "objectNumber",
          sort: 5,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "结算对象名称",
          field: "objectName",
          sort: 6,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "应付金额",
          field: "outAmount",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "应收金额",
          field: "inAmount",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "结算金额",
          field: "settlementAmount",
          sort: 18,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "付款日期",
          field: "outWriteoffTime",
          sort: 19,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "应付已核销金额",
          field: "outWriteoffAmount",
          sort: 1,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
        {
          name: "应付未核销余额",
          field: "outUnwriteoffAmount",
          sort: 1,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
        {
          name: "应收已核销金额",
          field: "inWriteoffAmount",
          sort: 1,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
        {
          name: "应收未核销金额",
          field: "inUnwriteoffAmount",
          sort: 1,
          isShow: true,
          width: "160",
          isTotal: false,
          isSort: false,
        },
        {
          name: "税点",
          field: "taxPoint",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "是否开票",
          field: "isInvoiceShow",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "票据类型",
          field: "invoiceTypeName",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "业务网点",
          field: "deptName",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },

        {
          name: "跟进人",
          field: "personInChargeName",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },

        {
          name: "结算方式",
          field: "settlementMethod",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "付款账期",
          field: "settlementPeriod",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "付款期限日期",
          field: "paymentTerms",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "账期",
          field: "accountPeriod",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
        {
          name: "逾期天数",
          field: "overdusDay",
          sort: 1,
          isShow: true,
          width: "120",
          isTotal: false,
          isSort: false,
        },
      ],
      sortName: "外请应付账单明细", //  排序名
      pageGroupName: "InviteDetailed",
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.GetData();
  },
  methods: {
    // 获取外请应付账款明细
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.startBusinessDate = this.startTime_a
        ? this.startTime_a + " 00:00:00"
        : "";
      this.queryData.endBusinessDate = this.endTime_a
        ? this.endTime_a + " 23:59:59"
        : "";
      this.$API.DispatchProfitList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---外请应付账款明细`);
        }
      });
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 导出
    exportData() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    // 表格设置
    SetTable() {},
    // 打印
    printData() {},
  },
};
</script>
        <style scoped lang="less">
</style>
                          